<template>
  <fragment>
    <!-- <b-button class="mb-3 d-print-none" @click="handlePrint()">{{
      $t('buttons.print')
    }}</b-button> -->

    <b-row class="d-none d-print-flex">
      <b-col
        ><b-list-group flush>
          <b-list-group-item class="border-0 p-1"
            ><strong>{{ company.name }}</strong></b-list-group-item
          >
          <b-list-group-item class="border-0 p-1">{{
            company.address
          }}</b-list-group-item>
          <b-list-group-item class="border-0 p-1">{{
            company.city
          }}</b-list-group-item>
          <b-list-group-item class="border-0 p-1">{{
            company.number
          }}</b-list-group-item>
        </b-list-group></b-col
      >
      <b-col>
        <b-list-group flush>
          <b-list-group-item class="border-0 p-1"
            ><strong>{{ user.companyName }}</strong></b-list-group-item
          >
          <b-list-group-item class="border-0 p-1">{{
            user.name
          }}</b-list-group-item>
          <b-list-group-item class="border-0 p-1">{{
            user.email
          }}</b-list-group-item>
          <b-list-group-item class="border-0 p-1">{{
            user.companyNo
          }}</b-list-group-item>
        </b-list-group></b-col
      >
    </b-row>

    <b-table
      responsive
      show-empty
      empty-text="No payment history found"
      :busy="loading"
      sort-icon-left
      :fields="fields"
      :items="paymentHistory"
      :per-page="perPage"
      :current-page="currentPage"
      @row-clicked="toggleTableRow"
    >
      <template v-slot:table-busy>
        <div class="text-center">
          <b-spinner
            variant="primary"
            class="align-middle"
            :label="$t('messages.loading')"
          ></b-spinner>
        </div>
      </template>

      <template v-slot:cell(date)="data">
        {{ data.item.date | date }}
      </template>

      <template v-slot:cell(amount)="data">
        {{ (data.item.amount / 100) | currency(user.currency) }}
      </template>

      <template v-slot:cell(vat)="data">
        {{ (data.item.vat / 100) | currencyDecimals(user.currency) }}
      </template>

      <template v-slot:cell(method)="data">
        <b-icon
          v-if="data.item.method === 'CC'"
          icon="credit-card"
          font-scale="1.8"
          aria-label="Credit card"
        />
        <b-icon v-else icon="receipt" font-scale="1.8" aria-label="Invoice" />
      </template>

      <template v-slot:cell(action)="data">
        <b-button @click="data.toggleDetails" class="d-print-none">{{
          data.detailsShowing ? $t('buttons.close') : $t('buttons.details')
        }}</b-button>
      </template>

      <template #row-details="row">
        <b-table-simple responsive hover v-if="row.item.items.length > 0">
          <b-thead head-variant="light">
            <b-tr>
              <b-th colspan="3">{{
                $t('user.payment_history.details_heading')
              }}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="(item, i) in row.item.items" :key="i">
              <td>{{ item.date | date }}</td>
              <td>{{ (item.amount / 100) | currency(user.currency) }}</td>
              <td>{{ item.name }}</td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </template>
    </b-table>

    <b-pagination
      class="d-print-none"
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      align="center"
      pills
    />
  </fragment>
</template>
<script>
import api from '../api/api';

export default {
  data() {
    return {
      loading: false,
      perPage: 12,
      currentPage: 1,
      paymentHistory: [],
      window: window,
      company: {
        name: 'Servicestart Sverige AB',
        address: 'Övre Slottsgatan 6',
        city: '753 10 Uppsala',
        number: '556670-4564',
      },
    };
  },
  mounted() {
    this.getPaymentHistory();

    if (this.user.country !== 'SE') {
      this.company = {
        name: 'Servicestart Ltd',
        address: 'Square Root Business Centre',
        city: 'Croydon, Surrey, CR0 2XQ',
        number: '6009640',
      };
    }
    setTimeout(() => this.handlePrint(), 500);
  },
  computed: {
    fields() {
      return [
        {
          key: 'date',
          label: this.$t('user.payment_history.date'),
          sortable: true,
        },
        {
          key: 'amount',
          label: this.$t('user.payment_history.amount'),
          sortable: true,
        },
        {
          key: 'vat',
          label: this.$t('user.payment_history.vat'),
        },
        {
          key: 'method',
          label: this.$t('user.payment_history.method'),
        },
        {
          key: 'action',
          label: '',
        },
      ];
    },
    user() {
      return this.$store.state.user;
    },
    rows() {
      return this.paymentHistory.length;
    },
  },
  methods: {
    toggleTableRow(item) {
      this.$set(item, '_showDetails', !item._showDetails);
    },
    expandAll() {
      return new Promise((resolve) => {
        for (const item of this.paymentHistory) {
          this.$set(item, '_showDetails', true);
        }
        resolve();
      });
    },
    collapseAll() {
      for (const item of this.paymentHistory) {
        this.$set(item, '_showDetails', false);
      }
    },
    handlePrint() {
      this.perPage = 100;
      this.currentPage = 1;
      this.expandAll()
        .then(() => window.print())
        .finally(
          () =>
            setTimeout(
              () => (window.parent.location.href = '/account/history'),
            ),
          0,
        );
    },
    getPaymentHistory() {
      this.loading = true;

      api
        .getPaymentHistory()
        .then((res) => (this.paymentHistory = res.data))
        .finally(() => (this.loading = false));
    },
  },
};
</script>
